import dayjs from "dayjs";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import duration from "dayjs/plugin/duration";
import isoWeek from "dayjs/plugin/isoWeek";
// Theoretically the dayjs object could be dynamically extended client side to have this formatting, but
// IMO it might more sense if it already has it.
import customParseFormat from "dayjs/plugin/customParseFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);

const _date = new Date();
/**
 * ISO format for a given date (ex: 2006-01-02)
 * @param {Date|number} timeValue
 */
export function toISODateString(timeValue) {
  _date.setTime(timeValue);
  return _date.toISOString().substring(0, 10);
}

export const MIN_MS = 60 * 1000;
export const HOUR_MS = 60 * MIN_MS;
export const DAY_MS = 24 * HOUR_MS;

/** Time since unix epoch in seconds. */
export function nowSec() {
  // uses floor to match dayjs` behaviour.
  return Math.floor(Date.now() / 1e3);
}

// Aggregate preparation of dayjs with commonly used modules.
export { dayjs };